// Máscara para campos do tipo monetário em Reais
angular.module("avlib").directive("avReaisMask", function(){
	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){

			var groupDigits = function(value){
				if (value == null || value == ""){
					return value;
				}else{
					if (value.length > 3){
						var currentGroup = value.substr(value.length-3);
						var nextInput = value.substr(0, value.length-3);
						return groupDigits(nextInput) + "." + currentGroup;
					}else{
						return value;
					}
				}
			};

			var formatReais = function(value){
				if (value === null || value == ""){
					return value;
				}
				/*
				 * Garantindo que estamos trabalhando com string
				 */
				value = ""+value;

				// Removendo todos os caracteres não numéricos:
				value = value.replace(/\D/g,'');

				// Removendo zeros em excesso, do lado esquerdo do número. Não podemos eliminar todos os
				// zeros à esquerda pois alguns são parte de valores menos do que R$ 1,00.
				if (value.length > 3 && value.match(/0+\d{3,}/g)){
					var nonZeroIndex = value.search(/[1-9]/g);
					value = value.substr(nonZeroIndex, value.length-nonZeroIndex);
				}

				// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
				if (value.length > 2){
					var decimalPart = value.substr(value.length-2);
					var thousandsPart = groupDigits(value.substr(0,value.length-2));
					value =  thousandsPart + "," + decimalPart;
				}else{
					if (value.length == 1){
						value = "0,0"+value;
					}else{
						value = "0,"+value;
					}
				}
				// Acrescentando o sinal monetário
				value = "R$ " + value;

				return value;
			};

			var reaisParser = function(viewValue){
				if (viewValue == ""){
					ctrl.$setViewValue("");
					ctrl.$render();
					return null;
				}
				/*
				 * A entrada R$ 0,0 indica que o valor original era R$ 0,00 e o usuário digitou backspace,
				 * na tentativa de apagar o valor que se encontrava na caixa. Esse é o nosso sinal para
				 * eliminar todos caracteres da caixa e atribuir nulo ao modelo.
				 */
				if (viewValue == "R$ 0,0"){
					ctrl.$setViewValue("");
					ctrl.$render();
					return null;
				}
				/*
				 * Se não existe nenhum valor no campo e o usuário digita um caracter não-numérico, mantemos
				 * o campo nulo.
				 */
				if (!viewValue.startsWith("R$") && !viewValue.match(/\d/g)){
					ctrl.$setViewValue("");
					ctrl.$render();
					return null;
				}

				var formattedReais = formatReais(viewValue);
				ctrl.$setViewValue(formattedReais);
				ctrl.$render();

				if (formattedReais == null){
					return null;
				}else{
					var modelValue = formattedReais.replace(/[^,\d]/g,'');
					modelValue = modelValue.replace(/,/g,'.');
					var parsed = parseFloat(modelValue);
					return parsed;
				}
			};

			var reaisFormatter = function(modelValue){
				if (modelValue === null){
					return "";
				}else{
					if (isNaN(modelValue)){
						ctrl.$modelValue = null;
						return null;
					}else{
						ctrl.$modelValue = modelValue;
						return formatReais(modelValue.toFixed(2));
					}
				}
			};

			ctrl.$parsers.push(reaisParser);
			ctrl.$formatters.push(reaisFormatter);
		}
	};
});
